module.exports = __webpack_public_path__ + "static/media/about_22025.bcfcace6.png";